
export enum MessageType {
  TIMER_PLAY = 'TIMER_PLAY',
  TIMER_PAUSE = 'TIMER_PAUSE',
  TIMER_RESTART = 'TIMER_RESTART',
  TIMER_SYNC_STATE = 'TIMER_SYNC_STATE',
  WHITEBOARD_OPEN = 'WHITEBOARD_OPEN',
  WHITEBOARD_CLOSE = 'WHITEBOARD_CLOSE',
  ATHLETE_VIEW_OPEN = 'ATHLETE_VIEW_OPEN',
  ATHLETE_VIEW_CLOSE = 'ATHLETE_VIEW_CLOSE',
  WORKOUT_NEXT = 'WORKOUT_NEXT',
  WORKOUT_PREVIOUS = 'WORKOUT_PREVIOUS',
  SLIDESHOW_CHANGE = 'SLIDESHOW_CHANGE',
  SLIDESHOW_CLOSE = 'SLIDESHOW_CLOSE',
}

export type MessageTypeKey = keyof typeof MessageType;

export interface AppMessage {
  type: MessageTypeKey;
  url?: string;
  elapsedTime?: number;
  timerId?: string;
  isRunning?: boolean;
  slideIndex?: number;
  timestamp?: number;
}
